import { render, staticRenderFns } from "./newPrivateMessage.vue?vue&type=template&id=23fe51e6&"
import script from "./newPrivateMessage.vue?vue&type=script&lang=js&"
export * from "./newPrivateMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports